import * as React from 'react';

interface Props {
  fill: string;
  label: string;
}

export const LegendEntry: React.FC<Props> = (props) => {
  const { fill, label } = props;
  return (
    <div className="flex items-center space-x-1">
      <svg className="rounded w-4 h-4 flex-shrink-0">
        <rect width="100%" height="100%" fill={fill} />
      </svg>
      <h5>{label}</h5>
    </div>
  );
};
LegendEntry.displayName = 'Components.LegendEntry';
